export default "__VITE_ASSET__BYUzQYac__"